module.exports = __webpack_public_path__ + "img/cooperate05.e72d0150.png";